import { Controller } from "stimulus";
import { FocusTrap } from 'shared/assets/javascript/accessibility/focusTrap.js';

export default class extends Controller {
  static targets = [
    'closeButton',
  ];

  get footerToggle() {
    return document.querySelector('.footer-bar__chat');
  }

  get headerToggle() {
    return document.querySelector('.header-bar__phone--mobile-only')
  }

  initialize() {
    this.state = {
      active: false,
    };
  }

  connect() {
    this.footerToggle.addEventListener('click', this.modalOpen.bind(this))
    if (this.headerToggle) {
      this.headerToggle.addEventListener('click', this.modalOpen.bind(this))
    }
    this.closeButtonTarget.addEventListener('click', this.modalClose.bind(this))
    this.element.addEventListener('keyup', this.handleKeyUp.bind(this));

    this.modal = this.element
    this.modalToggle = this.footerToggle
    this.focusTrapInstance = new FocusTrap([this.modalToggle, this.modal])
  }

  modalOpen(event){
    if (this.footerToggle.contains(event.target)) {
      this.modalToggle = this.footerToggle;
    } else {
      this.modalToggle = this.headerToggle;
    }
    this.state.active = true
    this.element.classList.add('active');
    document.body.classList.add('-is-open-modal');
    this.focusTrapInstance.set();
    this.closeButtonTarget.focus();
  }

  modalClose(){
    this.state.active = false;
    this.element.classList.remove('active');
    document.body.classList.remove('-is-open-modal');
    this.focusTrapInstance.unset();
    this.modalToggle.focus();
  }

  handleKeyUp(event) {
    if ((event.keyCode == 27) && this.state.active) {
      this.modalClose();
    }
  }
}

